enum OrderFinishedListingPublicStatus {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  PUBLISHED = "PUBLISHED",
}

export default OrderFinishedListingPublicStatus;
